<template>
  <div>
    <div v-if="data.meta === null" class="badge badge-danger font-weight-bold">ثبت نشده !</div>
    <div v-if="data.meta !== null && meta.type === 'comment'">
      <div class=" badge badge-dark font-weight-bold" v-if="data.meta[0].Comment">{{ data.meta[0].Comment }}</div>
      <div class="badge badge-danger font-weight-bold" v-else>توضح ندارد!</div>
    </div>
    <div v-if="data.meta !== null && meta.type === 'actions'">
      <div class=" badge badge-warning font-weight-bold" v-if="data.meta[0].Action">
        <div v-if="data.meta[0].Action === 'charge_balance'">شارژ کیف پول</div>
        <div v-if="data.meta[0].Action === 'charge_panel'">شارژ پنل</div>
        <div v-if="data.meta[0].Action === 'panel'"> پنل</div>
        <div v-if="data.meta[0].Action === 'production_buy'">خرید محصول</div>
        <div v-if="data.meta[0].Action === 'transfer'">انتقال</div>
        <div v-if="data.meta[0].Action === 'charge_production'">شارژ محصول</div>
        <div v-if="data.meta[0].Action === 'commission_parent'">عاملیت</div>
        <div v-if="data.meta[0].Action === 'coupon_production'">تخفیف محصول</div>
        <div v-if="data.meta[0].Action === 'refund_production'">بازگشت محصول</div>
      </div>
      <div class="badge badge-danger" v-else>توضح ندارد!</div>
    </div>
    <div v-if="data.meta !== null && meta.type === 'service'">
      <div class="font-weight-bold badge badge-primary" v-if="data.meta[0].service">
        {{ data.meta[0].service  | serviceType }}
      </div>
    </div>
    <div v-if="data.meta !== null && meta.type === 'productId'">
      <div class="h6 font-weight-bold" v-if="data.meta[0].ProductId">
        {{ data.meta[0].ProductId }}
      </div>
    </div>


    <div v-if="data.meta !== null && meta.type === 'adminType'">
      <v-btn x-small class="btn-active" @click="showMessage(data)" v-if="data.admin_type === 'admin'">
        توسط مدیر
      </v-btn>
      <v-chip v-else-if="data.admin_type === 'online'"
              label
              color="#698745"
              small
              outlined>
        واریز آنلاین
      </v-chip>
      <v-chip v-else-if="data.admin_type === 'refund'"
              label
              color="#FF4000"
              small
              outlined>
        تراکنش های اصلاحی
      </v-chip>
      <v-chip v-else-if="data.admin_type === 'deposit'"
              label
              color="#0080AB"
              small
              outlined>
واریز
      </v-chip>
      <v-chip v-else-if="data.admin_type === 'withdraw'"
              label
              color="#23A400"
              small
              outlined>
برداشت
      </v-chip>
      <v-chip v-else-if="data.admin_type === 'agency'"
              label
              color="#820038"
              small
              outlined>
عاملیت
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: "Meta",
  props: {
    data: {},
    meta: {},
    showMessage:{
      type: Function,
      require:false
    }
  }
}
</script>

<style scoped>

</style>